import { defineComponent as t, openBlock as r, createElementBlock as o, mergeProps as n, renderSlot as s } from "vue";
import "./ghl-ui.es226.js";
const a = t({
  name: "UITextMdNormal",
  inheritAttrs: !1
}), l = t({
  ...a,
  setup(m) {
    return (e, c) => (r(), o("div", n(e.$attrs, { class: "hl-text-md-normal" }), [
      s(e.$slots, "default")
    ], 16));
  }
}), _ = l;
export {
  _ as default
};
